module.exports = __webpack_public_path__ + "img/laboratorio_16-9_960.b1ca30a9.jpg";